var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 8C12.8 9.27304 12.2943 10.4939 11.3941 11.3941C10.4939 12.2943 9.27304 12.8 8 12.8C6.72696 12.8 5.50606 12.2943 4.60589 11.3941C3.70571 10.4939 3.2 9.27304 3.2 8C3.2 6.72696 3.70571 5.50606 4.60589 4.60589C5.50606 3.70571 6.72696 3.2 8 3.2C8.456 3.2 8.9 3.266 9.32 3.386L10.262 2.444C9.566 2.156 8.804 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8M5.546 6.848L4.7 7.7L7.4 10.4L13.4 4.4L12.554 3.548L7.4 8.702L5.546 6.848Z",
    fill: "#E8B34F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circle-tick.515020c7f4f684f6bea3dcafc93bc8f7.svg";
export { ForwardRef as ReactComponent };